// Android WebView loses its GPU surface when the app is backgrounded; on some
// devices fixed/composited layers are not re-rasterized on resume until an
// input event arrives (symptom: white screen until the user taps). This forces
// compositor flushes when the app becomes visible again. Multiple triggers
// (visibilitychange / resume / pageshow / focus) because OEMs differ in which
// events actually fire on resume, and multiple delayed passes because the GPU
// surface may not be recreated yet when the first event arrives.
import { Capacitor } from '@capacitor/core';
import { diag } from './diagLog';

export function initNativeResumeRepaint() {
  if (!Capacitor.isNativePlatform()) return;

  const repaintPass = () => {
    requestAnimationFrame(() => {
      document.body.style.transform = 'translateZ(0)';
      // eslint-disable-next-line no-unused-expressions
      document.body.offsetHeight;
      requestAnimationFrame(() => {
        document.body.style.transform = '';
      });
    });
  };

  let timers = [];
  const forceRepaint = (src) => {
    diag('REPAINT_TRIGGER', { src });
    timers.forEach(clearTimeout);
    repaintPass();
    timers = [250, 900].map((ms) => setTimeout(repaintPass, ms));
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') forceRepaint('visibilitychange');
  });
  window.addEventListener('resume', () => forceRepaint('resume'));
  window.addEventListener('pageshow', () => forceRepaint('pageshow'));
  window.addEventListener('focus', () => forceRepaint('focus'));
}
